import { Routes } from '@angular/router';
import { TrainingTrackingBaseComponent } from '../../projects/TrainingTracking/src/training-tracking-base/training-tracking-base.component';
import { TimelogBaseComponent } from '../../projects/Timelog/src/timelog-base/timelog-base.component';
import { WatermanagerBase } from '../../projects/Watermanager2/src/watermanager-base/watermanager-base.component';
import timelogRouteConfig from '../../projects/Timelog/src/timelog-base/Routes';
import watermanagerRouteConfig from '../../projects/Watermanager2/src/watermanager-base/Routes';
import trainingtrackingRouteConfig from '../../projects/TrainingTracking/src/training-tracking-base/Routes';
import { AssetsBaseComponent } from 'projects/Assets/src/assets-base/assets-base.component';
import AssetsRouteConfig from 'projects/Assets/src/assets-base/Routes';
import { EquipmentRegistrationBaseComponent } from '../../projects/EquipmentRegistration/src/equipment-registration-base/equipment-registration-base.component';
import equipmentRegistrationRouteConfig from '../../projects/EquipmentRegistration/src/equipment-registration-base/Routes';

const Routes: Routes = [
  { path: '', redirectTo: 'kursus', pathMatch: 'full' },
  {
    path: 'kursus',
    component: TrainingTrackingBaseComponent,
    children: trainingtrackingRouteConfig,
  },
  {
    path: 'timelog',
    component: TimelogBaseComponent,
    children: timelogRouteConfig,
  },
  {
    path: 'assets',
    component: AssetsBaseComponent,
    children: AssetsRouteConfig,
  },
  {
    path: 'udstyr',
    component: EquipmentRegistrationBaseComponent,
    children: equipmentRegistrationRouteConfig,
  },
  {
    path: 'watermanager',
    component: WatermanagerBase,
    children: watermanagerRouteConfig,
  },
];
export { Routes };
